
import ArrowRight1 from "../../../assets/duotone/ArrowRight1.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function ArrowRight1Icon({ className, dataTestid = "ArrowRight1Icon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <ArrowRight1 data-testid={dataTestid} className={classes} {...rest} />
  );
}
